import React, { useState } from "react";
import { Icon } from "@iconify/react";

/**
 * SectionFaq Component
 * Frequently Asked Questions section with manual accordion
 */

interface FaqItemProps {
  question: string;
  answer: string;
  isExpanded: boolean;
  onChange: () => void;
}

const FaqItem: React.FC<FaqItemProps> = ({
  question,
  answer,
  isExpanded,
  onChange,
}) => {
  return (
    <div className="bg-white p-2 shadow-lg">
      <div className="bg-[#FAFAFA] overflow-hidden transition-all duration-300 ">
        {/* Accordion Header */}
        <button
          onClick={onChange}
          className="w-full p-3  flex justify-between items-center bg-transparent border-none cursor-pointer text-left"
        >
          <p className="font-open-sans font-semibold text-base md:text-xl leading-7 tracking-[0.2px] text-base-black m-0">
            {question}
          </p>
          <Icon
            icon="bxs:down-arrow"
            fontSize={18}
            className={`text-base-black flex-shrink-0 ml-4 transition-transform duration-300 ${
              isExpanded ? "rotate-180" : "rotate-0"
            }`}
          />
        </button>

        {/* Accordion Content */}
        <div
          className="overflow-hidden transition-all duration-300"
          style={{
            maxHeight: isExpanded ? "1000px" : "0",
            opacity: isExpanded ? 1 : 0,
          }}
        >
          <div className="px-3 pb-3">
            <p className="font-open-sans font-normal text-sm md:text-base leading-7 tracking-[0.16px] text-base-grey whitespace-pre-wrap m-0">
              {answer}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const SectionFaq: React.FC = () => {
  const [expanded, setExpanded] = useState<number>(0);

  const faqData = [
    {
      question: "Apa itu program Agent Pekalen Rafting?",
      answer:
        "Program kemitraan untuk individu/komunitas/bisnis yang mempromosikan dan menjual paket rafting Pekalen. Anda dapat komisi dari setiap order yang berhasil.",
    },
    {
      question: "Siapa yang bisa mendaftar?",
      answer: `• Perorangan (minimal 18 tahun)
• Komunitas/EO/Travel agent
• UMKM/Toko online/Content creator`,
    },
    {
      question: "Syarat pendaftaran apa saja?",
      answer: `Siapkan:
• KTP (foto jelas)
• Nomor WhatsApp aktif & email
• Rekening bank atas nama sendiri (BCA/BRI/BNI/mandiri, dll)
• Link kanal promosi (IG/TikTok/Marketplace/Website)
• NPWP (opsional, untuk potong pajak otomatis)`,
    },
    {
      question: "Apakah ada biaya pendaftaran?",
      answer: "Tidak ada biaya pendaftaran. Gratis.",
    },
    {
      question: "Bagaimana alur pendaftarannya?",
      answer: `Isi formulir online
Unggah dokumen
Verifikasi tim (± [1–2 hari kerja])
Dapat akun + kode/link referral + kit promosi
Mulai jualan`,
    },
    {
      question: "Berapa lama proses verifikasi?",
      answer:
        "Rata-rata [1–2 hari kerja] setelah berkas lengkap. Jika lebih dari [3×24 jam] belum ada kabar, chat admin.",
    },
    {
      question: "Bagaimana saya mendapatkan komisi?",
      answer:
        "Kamu akan mendapat komisi [xx%] dari nilai paket yang terkonfirmasi & selesai trip. (Atur angka sesuai kebijakanmu.)",
    },
    {
      question: "Kapan komisi dibayarkan?",
      answer:
        "Setiap [hari/tanggal] atau [mingguan/bulanan], minimal payout Rp[xx]. Order yang dibatalkan/refund tidak dihitung.",
    },
    {
      question: "Metode pembayaran komisi?",
      answer:
        "Transfer bank ke rekening yang Anda daftarkan. E-wallet bisa jika diaktifkan (opsional).",
    },
    {
      question: "Apakah ada target penjualan?",
      answer:
        "Tidak wajib target, tapi akun nonaktif otomatis jika tidak ada penjualan selama [60/90] hari. Bisa diajukan aktif kembali via admin.",
    },
  ];

  const handleChange = (index: number) => {
    setExpanded(expanded === index ? -1 : index);
  };

  return (
    <div
      data-aos="fade-up"
      className="flex flex-col justify-center p-6 md:p-8 lg:p-0 lg:py-12 gap-12 items-center lg:max-w-6xl lg:mx-auto"
    >
      <h2 className="font-bold md:text-[40px] text-[24px] tracking-[0.4px] text-base-black text-center m-0">
        Pertanyaan Umum
      </h2>

      <div className="flex flex-col gap-6 font-family-open-sans">
        {faqData.map((faq, index) => (
          <FaqItem
            key={index}
            question={faq.question}
            answer={faq.answer}
            isExpanded={expanded === index}
            onChange={() => handleChange(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default SectionFaq;
